import { Injectable, Inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseModel } from '../models/base.model';
import { LogService } from '../../core/services/log.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export abstract class BaseService<T extends BaseModel> {

  constructor(@Inject(HttpClient) protected http: HttpClient,
              @Inject(LogService) protected log: LogService,
              @Inject(MessageService) protected messageService: MessageService,
              @Inject(TranslateService) protected translateService: TranslateService) { }

}
